import type { FC } from "react";
import { Box, Stack, Typography } from "@mui/material";

type ConnectionsEmptyStateProps = {
  title: string;
  body: string;
};

export const ConnectionsEmptyState: FC<ConnectionsEmptyStateProps> = ({ title, body }) => (
  <Box
    sx={{
      border: "1px solid",
      borderColor: theme => theme.palette.grey["300"],
      borderRadius: 1,
      display: "grid",
      height: "120px",
      placeContent: "center",
    }}
  >
    <Stack sx={{ gap: 0.5, alignItems: "center", textAlign: "center" }}>
      <Typography
        sx={{
          fontSize: theme => theme.typography.pxToRem(14),
          fontWeight: 600,
          color: theme => theme.palette.text.tertiary,
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          fontSize: theme => theme.typography.pxToRem(12),
          maxWidth: "30rem",
          color: theme => theme.palette.text.tertiary,
        }}
      >
        {body}
      </Typography>
    </Stack>
  </Box>
);
